import {Typography} from "@mui/material";

export const SectionHeader: React.FC<{label: string}> = ({label}) => {
    return (
        <Typography fontSize={16} textTransform="uppercase" fontWeight={500} color="#2B303F">
            {label}
        </Typography>
    );
};
